import { Button, Card, Icon } from "@stellar/design-system";

import { DisbursementEmailPreview } from "@/components/DisbursementEmailPreview";
import { DisbursementSmsPreview } from "@/components/DisbursementSmsPreview";

import { SummaryRow } from "./SummaryRow";

import { Disbursement, hasPhone } from "@/types";


interface StepInvitationProps {
  draftDetails?: Disbursement;
  language: string;
  orgName: string;
  smsTemplate: string;
  isDraftEnabled: boolean;
  isSavePending: boolean;
  onNext: () => void;
  onBack: () => void;
  onSaveDraft: () => void;
}

export const StepInvitation = ({
  draftDetails,
  language,
  orgName,
  smsTemplate,
  isDraftEnabled,
  isSavePending,
  onNext,
  onBack,
  onSaveDraft,
}: StepInvitationProps) => (
  <form
    onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      onNext();
    }}
    className="DisbursementForm"
  >
    <SummaryRow
      walletName={draftDetails?.wallet?.name}
      assetCode={draftDetails?.asset?.code}
      registrationContactType={draftDetails?.registrationContactType}
    />
    <Card>
      {hasPhone(draftDetails?.registrationContactType) ? (
        <DisbursementSmsPreview
          orgName={orgName}
          walletName={draftDetails?.wallet?.name ?? ""}
          language={language}
          customSmsTemplate={smsTemplate}
        />
      ) : (
        <DisbursementEmailPreview
          walletName={draftDetails?.wallet?.name ?? ""}
          language={language}
        />
      )}
    </Card>

    <div className="DisbursementButtons">
      <Button
        variant="tertiary"
        size="md"
        icon={<Icon.ArrowLeft />}
        iconPosition="left"
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault();
          onBack();
        }}
        disabled={isSavePending}
      >
        Back
      </Button>
      <div className="DisbursementButtons--continue">
        <Button
          variant="tertiary"
          size="md"
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            e.preventDefault();
            onSaveDraft();
          }}
          disabled={!isDraftEnabled || isSavePending}
          isLoading={isSavePending}
        >
          Save draft
        </Button>
        <Button
          variant="primary"
          size="md"
          icon={<Icon.ArrowRight />}
          iconPosition="right"
          type="submit"
          disabled={isSavePending}
        >
          Next
        </Button>
      </div>
    </div>
  </form>
);

